// The invite link from the email and every in-app hop back to the invite modal
// share this shape; the tokens are the only state the invite flow carries.
export const communityInviteModalUrl = (tokenId: string, token: string): string =>
  `/community?t=${encodeURIComponent(tokenId)}&token=${encodeURIComponent(token)}`;
